<template>
    <div class="body">
      <div class="header">
        <el-form :model="SelectOrderInformationDTO" :inline="true">
          <el-form-item label="上传日期">
            <el-date-picker
              size="small"
              v-model="date"
              type="daterange"
              :picker-options="cellClassName"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              @change="chooeDate"
            ></el-date-picker>
          </el-form-item>





            <el-form-item  label="客户名称">
          <el-select clearable size="small" v-model="SelectOrderInformationDTO.customerName" allow-create filterable>
            <el-option
              v-for="item in customerName"
              clearable
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>

        <el-form-item  label="操作员" >
          <el-select clearable size="small" v-model="SelectOrderInformationDTO.operator" allow-create filterable>
            <el-option
              v-for="item in operator"
              clearable
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>

            <el-form-item label="订单名称">
              <el-input
                size="small"
                v-model="SelectOrderInformationDTO.orderName"
                placeholder=""
              ></el-input>
            </el-form-item>
            <el-form-item label="订单编号">
              <el-input
                size="small"
                v-model="SelectOrderInformationDTO.orderId"
                placeholder=""
              ></el-input>
            </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="serchInfo">
              搜索
            </el-button>
            <el-button @click="submit" size="small" type="primary">下载源文件</el-button>
            <el-button @click="downLoadKeeps" size="small" type="primary">下载存档文件</el-button>
            <el-button @click="downLoadFloors" size="small" type="primary">下载底板文件</el-button>
            <el-button @click="downLoadPanels" size="small" type="primary">下载面板文件</el-button>
            <el-button @click="downLoadManuscripts" size="small" type="primary">下载字稿文件</el-button>
            <el-button @click="placeOrder" size="small" type="primary">下单</el-button>
            <el-button @click="sendingToManuscripts" size="small" type="success">发送至字稿拼版</el-button>
            <el-button size="small" type="danger" @click="handleDelete">删除</el-button>
          </el-form-item>
          <br>
        </el-form>
        <div style="display: flex">
          <!-- <el-button size="small" type="primary">导入</el-button> -->
          <!-- <el-button
            size="small"
            style="margin-left: 10px"
            type="primary"
            @click="exportExcelData"
          >
            导出
          </el-button> -->
        </div>
  </div>
      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          border
          style="width: 100%"
          :cell-style="styleBack"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>

        <el-table-column
    prop="thumbnailPath"
    label="缩略图"
    align="center"
    width="200" >
 <template slot-scope="scope">
 <el-popover placement="top-start" trigger="click">
 <!--trigger属性值：hover、click、focus 和 manual-->
 <a :href="scope.row.thumbnailPath"  target="_blank" title="查看最大化图片">
 <img :src="scope.row.thumbnailPath" style="max-height: 800px;max-width: 800px">
  </a>
  <img slot="reference" :src="scope.row.thumbnailPath" style="max-height: 50px;max-width: 50px cursor:pointer">
  </el-popover>
 </template>
</el-table-column>
<el-table-column
            prop="orderTime"
            align="center"
            label="下单时间"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="orderNumber"
            align="center"
            label="产品编号"
          ></el-table-column>
          <el-table-column
            prop="orderName"
            align="center"
            label="订单名称"
            width="130"
          ></el-table-column>
          <el-table-column
            prop="category"
            align="center"
            label="产品名称"
          ></el-table-column>
          <el-table-column
            prop="subclass"
            align="center"
            label="产品类别"
            width="130"
          ></el-table-column>
          <el-table-column
            prop="specifications"
            align="center"
            label="规格"
            width="130"
          ></el-table-column>
          <el-table-column
            prop="totalPrice"
            align="center"
            label="单价"
            width="130"
          ></el-table-column>
          <el-table-column
            prop="number"
            align="center"
            label="数量"
          ></el-table-column>


          <el-table-column
            prop="productType"
            align="center"
            label="产品类型"
          ></el-table-column>

        <el-table-column label="操作" align="center" width="150">
            <template v-slot="{ row }">
              <el-link type="success" size="small" @click="handleEdit(row)">详情</el-link>|
              <el-link type="success" size="small" @click="tohandleEdit(row)">修改</el-link>|
              <el-link type="success" size="small" @click="againhandleEdit(row)">再下一单</el-link>
            </template>

          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>

      <el-dialog title="编辑详情" :visible.sync="dialogVisible" width="45%" :close-on-click-modal="false" :center="true">
          <el-form
            ref="accountForm"
            :model="accountForm"
            label-width="120px"
            class="demo-accountForm"
            v-bind:disabled="disabled"
          >
          <el-row>
          <el-col :span="12">
          <el-form-item style="margin-top: 5px" label="订单名称" prop="remark" >
          <el-input
          id="disabled"
            class="input-remark"
            size="small"
            v-model="accountForm.orderName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
  <el-col :span="12">
    <el-form-item style="margin-top: 5px" label="计件米数" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.pieceMeter"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

      </el-col>
</el-row>
<el-row>
          <el-col :span="12">
        <el-form-item style="margin-top: 5px" label="客户名称" prop="customerName">
          <el-select clearable size="small" v-model="accountForm.customerName" allow-create filterable>
            <el-option
              v-for="item in customerName"
              clearable
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </el-col>
  <el-col :span="12">
    <el-form-item style="margin-top: 5px" label="操作员" prop="operator">
          <el-select clearable size="small" v-model="accountForm.operator" allow-create filterable>
            <el-option
              v-for="item in operator"
              clearable
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </el-col>
</el-row>

<el-row>
          <el-col :span="12">
            <el-form-item style="margin-top: 5px" label="交货方式" prop="deliveryMethod">
          <el-select clearable size="small" v-model="accountForm.deliveryMethod" allow-create filterable>
            <el-option
              v-for="item in deliveryMethod"
              clearable
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>

      </el-col>
  <el-col :span="12">
    <el-form-item style="margin-top: 5px" label="收款账户" prop="collectionAccount">
          <el-select clearable size="small" v-model="accountForm.collectionAccount" allow-create filterable  >
            <el-option
              v-for="item in collectionAccount"
              clearable
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </el-col>
</el-row>

<el-row>
          <el-col :span="12">
<el-form-item style="margin-top: 5px" label="产品名称" prop="remark">
        <el-select clearable size="small" v-model="accountForm.category" @change="getProducts()" filterable>
          <el-option
            v-for="item in product"
            clearable
            :key="item"
          :label="item"
          :value="item"
          />
        </el-select>
      </el-form-item>
    </el-col>
  <el-col :span="12">
      <el-form-item style="margin-top: 5px" label="产品类别" prop="remark">
        <el-select clearable size="small" v-model="accountForm.productId"  @change="getProductInfo()" filterable>
          <el-option
            v-for="item in products"
            clearable
            :key="item.subclass"
          :label="item.subclass"
          :value="item.id"
          />
        </el-select>
      </el-form-item>
    </el-col>
</el-row>

<el-row>
          <el-col :span="12">
            <el-form-item style="margin-top: 5px" label="订单金额" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.totalPrice"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
  <el-col :span="12">
<!-- <el-form-item style="margin-top: 5px" label="下载状态" prop="remark">
          <el-select clearable size="small" v-model="accountForm.downloadStatus">
            <el-option
              v-for="item in downloadStatus"
              clearable
              :key="item.value"
            :label="item.label"
            :value="item.value"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item style="margin-top: 5px" label="规格" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.specifications"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
</el-row>
<el-row>
          <el-col :span="12">
            <el-form-item style="margin-top: 5px" label="已付款" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.amountPaid"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
  <el-col :span="12">
    <el-form-item style="margin-top: 5px" label="产品类型" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.productType"
            placeholder="请输入"
            maxlength=30
          ></el-input>
        </el-form-item>
      </el-col>

</el-row>

<el-row>
          <el-col :span="12">
        <el-form-item style="margin-top: 5px" label="下单时间" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.orderTime"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
  <el-col :span="12">
        <el-form-item style="margin-top: 5px" label="交货时间" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.deliveryTime"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
</el-row>


<el-form-item style="margin-top: 5px" label="绑定订单" prop="remark">
        <el-select clearable size="small" v-model="accountForm.orderId"  filterable>
          <el-option
            v-for="item in orderIds"
            clearable
            :key="item.orderName"
          :label="item.orderName"
          :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="数量" prop="field102">
          <el-input-number v-model="accountForm.number" placeholder="数量"></el-input-number>
</el-form-item>
        <el-row>
          <el-col :span="12">
        <el-form-item style="margin-top: 5px" label="工艺要求" prop="remark">
          <el-input
          type="textarea"
            :rows="3"
            v-model="accountForm.processRequirements"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
  <el-col :span="12">
        <el-form-item style="margin-top: 5px" label="备注" prop="remark">
          <el-input
          type="textarea"
            :rows="3"
            v-model="accountForm.remarks"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
</el-row>

        <!-- 上传图片 -->
                        <el-form-item label="上传源文件"  class="errorPageImg">

                               <el-upload
                                class="avatar-uploader"
                                action="api/serviceCenter/orderInfo/orderInfoUpload"
                                :data={access:this.access,id:this.accountForm.id}
                                name="files"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload1"
                                >
                                <img v-if="accountForm.path" :src="accountForm.path"  style="max-height: 100px;max-width: 100px cursor:pointer" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                                <!-- <el-upload
                                v-model="accountForm.path"
                                action="api/serviceCenter/orderInfo/orderInfoUpload"
                                    list-type="picture-card"
                                    name="files"
                                    :on-remove="handleRemove"
                                    :on-change="handleEditChange"
                                    :on-preview="handlePictureCardPreview"
                                    :on-success="uploadSuccess"
                                    :show-file-list=true
                                    :multiple=false
                                    :limit="limitImg"
                                    :class="{hide:hideUpload}"
                                    >
                                    <i class="el-icon-plus"></i>
                                    <img slot="reference" :src="accountForm.path" style="max-height: 50px;max-width: 50px cursor:pointer">
                                </el-upload> -->
                        </el-form-item>

                        <el-form-item label="上传缩略图"  class="errorPageImg">
                       <el-upload
                        class="avatar-uploader"
                        action="api/serviceCenter/orderInfo/orderThumbnailUpload"
                        name="files"
                        :show-file-list="false"
                        :on-success="thumbnailPathSuccess"
                        :before-upload="beforeAvatarUpload"
                        >
                        <img v-if="accountForm.thumbnailPath" :src="accountForm.thumbnailPath"  style="max-height: 100px;max-width: 100px cursor:pointer" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>

          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="dialogVisible = false">取 消</el-button>
            <el-button size="small" type="primary" @click="editAccount()">
              确 定
            </el-button>
          </span>
        </el-dialog>
    </div>
  </template>

  <script>
  import {selectOrder,selectOrderInfo,orderInfoBatchDelete,updateOrderInfo,orderInfoInsertOne ,selectProductCategory,selectAllCustomer,selectAllUser,selectProduct,selectAllDistribution,selectAllCollection,productSelectInfo,sendingToManuscripts} from '@/api/order/orderInfo'
  export default {
    data() {
      return {
        path:'',
        access:'',
        dialogVisible: false,
            dialogImageUrl: '',
            dialogVisibleTwo: false,
            hideUpload: false,
        isLock: false,
        pageSize: 10,
        disabled:false,
        param:'1800',
        total: 0,
        currentPage: 1,
        collectionAccount:[],
        fileList:[],
        materialType:[],
        operator:[],
        orderIds:[],
        multipleSelection: [],
        limitImg:1,
        deliveryMethod:[],
        downloadStatus: [{
          value: '0',
          label: '未下载'
        }, {
          value: '1',
          label: '已下载'
        }],
        cellClassName: {
          shortcuts: [
          {
              text: '最近一天',
              onClick(picker) {
                const end = new Date()

                const start = new Date()

                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三天',
              onClick(picker) {
                const end = new Date()

                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()

                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()

                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()

                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
                picker.$emit('pick', [start, end])
              }
            }
          ]

        },
        date: '',
        conTract: [],
        buttonInfo:[],
        SelectOrderInformationDTO:{
            orderId:'',
            orderName:'',
            operator:'',
            customerName:'',
            startTime: '',
            endTime: '',
            access: '',
            productType: ''
        },
        customerName:[],
        product:[],
        accountForm: {
          id:'',
          access:'',
          orderNumber:'',
          orderName:'',
          productType:'',
          specifications:'',
          unit:'',
          number: '',
          unitPrice: '',
          totalPrice: '',
          remarks: '',
          customerId: '',
          customerName: '',
          operator:'',
          orderTime:'',
          deliveryTime:'',
          deliveryMethod:'',
          pieceMeter:'',
          paymentStatus:'',
          downloadStatus:'',
          thumbnailPath:'',
          path:'',
          processRequirements:'',
          amountPaid:'',
          collectionAccount:'',
          productId:'',
          category:'',
          orderId:'',
          subclass:'',
          number:1,
          listPrice:''
          },
          products:'',
          ProductFindDTO:{

          fileName:'',
          materialType:'',
            startTime: '',
            endTime: '',
            access: '',
            name:'',
            number:'',
            category:'',
            subclass:'',
            nature:'',
        },
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          values: ''
        },
        DeleteDTO:{
          id:'',
          status:''
        }

      }
    },
    created(){
   this.SelectOrderInformationDTO.orderId = this.$route.query.orderId;
},
    beforeMount(){

    },

    async  mounted() {
      this.access=localStorage.getItem("access")
      this.SelectOrderInformationDTO.access=localStorage.getItem("access")
      this.getDeliveryMethod();
      this.getCustomer();
      this.getProduct();
      this.getOperator();
      this.getCollectionAccount();
      this.getOrderIds();
      this.getTableData();
    },

    methods: {
      // handlePictureCardPreview(file) {
      //   this.dialogImageUrl = file.url;
      //   this.dialogVisible = true;
      // },
      // uploadSuccess(response,file,fileList){
      //   console.log(response,file,fileList)
      // },
      // handleEditChange (file, fileList) {
      //   this.hideUpload = fileList.length >= this.limitImg;
      //       },
      //   handleRemove (file, fileList) {
      //       this.hideUpload = fileList.length >= this.limitImg
      //       },
      //   messageAlert(){
      //       this.$message({
      //           message: '恭喜你,提交成功',
      //           type: 'success'
      //       });
      //   },

      getProducts(){
        this.ProductFindDTO.category=this.accountForm.category
        this.ProductFindDTO.access=localStorage.getItem("access")
        productSelectInfo(this.currentPage, 10000, this.ProductFindDTO).then((res) => {
          this.products = res.data.data.records
         // this.total = Number(res.data.data.total)
        })
      },
      getProductInfo(){
        selectProduct(this.accountForm.productId).then((res) => {
         this.accountForm.totalPrice=res.data.data.listPrice
         this.accountForm.specifications=res.data.data.specifications
         this.accountForm.thumbnailPath=res.data.data.thumbnailPath
        //  this.total = Number(res.data.data.total)
        })
      },
      handleAvatarSuccess(res, file) {
        this.accountForm.path = res.data.ori_file[0];
        this.accountForm.id=res.data.ori_file[1];
      },

      thumbnailPathSuccess(res, file){
        this.accountForm.thumbnailPath = res.data.ori_file[0];
      },

      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
      getCustomer(){
        selectAllCustomer(this.access).then((res) => {
          this.customerName = res.data.data
        //  this.total = Number(res.data.data.total)
        })
      },

      getOperator(){
        selectAllUser(this.access).then((res) => {
          this.operator = res.data.data
        })
      },

      getDeliveryMethod(){
        selectAllDistribution(this.access).then((res) => {
          this.deliveryMethod = res.data.data
        })
      },

      getCollectionAccount(){
        selectAllCollection(this.access).then((res) => {
          this.collectionAccount = res.data.data
        })
      },
      getOrderIds(){
        selectOrder(this.access).then((res) => {
          this.orderIds = res.data.data
        })
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getTable()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getTable()
      },
    getTableData() {
        selectOrderInfo(this.currentPage, this.pageSize, this.SelectOrderInformationDTO).then((res) => {
          this.conTract = res.data.data.records
          this.total = Number(res.data.data.total)
        })
      },
      handleEdit(row){
          this.disabled=true
          this.dialogVisible=true
          this.accountForm=row
          // this.path = row.thumbnailPath
      },
      placeOrder(row){
        this.dialogVisible=true
        this.accountForm = Object.assign({},this.$options.data().accountForm);
        this.accountForm.access=localStorage.getItem("access")
        orderInfoInsertOne(this.accountForm).then((res) => {
          this.accountForm.id=res.data.data.id
          this.accountForm.orderNumber=res.data.data.orderNumber
        })
        this.disabled=false
          this.accountForm.orderTime=this.getCurrentTime()
          this.accountForm.deliveryTime= this.getdeliveryTime()
         this.getTable()
      },
      againhandleEdit(row){
        this.dialogVisible=true
          this.accountForm=row
          this.accountForm.id=''
        orderInfoInsertOne(this.accountForm).then((res) => {
          this.accountForm.id=res.data.data.id
          this.accountForm.orderNumber=res.data.data.orderNumber
        })
        this.disabled=false
          this.accountForm.orderTime=this.getCurrentTime()
          this.accountForm.deliveryTime= this.getdeliveryTime()
         this.getTable()
      },
      tohandleEdit(row){
        this.disabled=false
        this.dialogVisible=true
          this.accountForm=row
      },
     getProduct(){
        this.ProductFindDTO.access=localStorage.getItem("access")
        selectProductCategory(this.ProductFindDTO).then((res) => {
          this.product = res.data.data
        })
        },

      editAccount() {
        updateOrderInfo(this.accountForm).then((res) => {
            if (res.data.msg === '操作成功') {
                this.$message({
                  type: 'success',
                  message: '修改成功!',
                }),
                this.getTable()
                this.dialogVisible = false
              } else if (res.data.msg !== '操作成功') {
                this.$message({
                  type: 'info',
                  message: res.data.data
                })
              }
          })
        },

        beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传缩略图图片只能是 JPG/PNG/JPEG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传缩略图大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      beforeAvatarUpload1(file) {
        const isLt20M = file.size / 1024 / 1024 < 20;
        if (!isLt20M) {
          this.$message.error('上传文件大小不能超过 20MB!');
        }
        return  isLt20M;
      },
      getCurrentTime() {
        //获取当前时间并打印
        var _this = this;
    let yy = new Date().getFullYear();
    let mm = new Date().getMonth()+1;
    let dd = new Date().getDate();
    let hh = new Date().getHours();
    let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
    let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
    _this.gettime = yy+'-'+mm+'-'+dd+' '+hh+':'+mf+':'+ss;

    return _this.gettime;
    },
    getdeliveryTime() {
        //获取当前时间并打印
        var _this = this;
    let yy = new Date().getFullYear();
    let mm = new Date().getMonth()+1;
    let dd = new Date().getDate()+1;
    let hh = new Date().getHours();
    let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
    let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
    _this.gettime = yy+'-'+mm+'-'+dd+' '+hh+':'+mf+':'+ss;
    return _this.gettime;
    },
    sendingToManuscripts(row){
      sendingToManuscripts(this.multipleSelection).then((res)=>{
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
        if(res.data.code===10000){
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '发送字稿拼版成功!',
              }),
              this.getTable()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            }
      })

    },
      handleDelete(row) {
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
      this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          orderInfoBatchDelete(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              }),
              this.getTable()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    find(data){
      this.SelectOrderInformationDTO.materialType=data
       this.getTable();
    },

    getTable(){
        selectOrderInfo(this.currentPage, this.pageSize, this.SelectOrderInformationDTO).then((res) => {
          this.conTract = res.data.data.records
          this.total = Number(res.data.data.total)
        })
    },
      deleteInfo(){
        bathDeleteFile(this.multipleSelection).then((res) => {
            if(res.data.code===10000){
              this.getTable()
            }
        })
      },

      handleSelectionChange(val) {
        this.DeleteDTO=val
        this.multipleSelection = val;
      },
      // 导出
      exportExcelData() {
        exportData(this.searchForm, this.currentPage, this.total)
          .then((res) => {
            if (res.status == 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      chooeDate(e) {
        // console.log(e)
        if (e) {
          this.SelectOrderInformationDTO.startTime = e[0]
          this.SelectOrderInformationDTO.endTime = e[1]
        } else if (!e) {
          this.SelectOrderInformationDTO.startTime = ''
          this.SelectOrderInformationDTO.endTime = ''
        }
      },

      // 搜索
      serchInfo() {
        this.getTableData()
      },

      submit() {
      if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
      let orderName=this.multipleSelection[0].orderName;
          this.$message({
                type: 'success',
                message: '正在死命下载中,请稍等!!!!',
              }),
      fetch("api/serviceCenter/orderInfo/downLoad", {
      body: JSON.stringify(this.multipleSelection),
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(res => {
      this.getTable()
      res.blob().then(blob => {
        // 转化为blobURL后再通过a标签下载
        console.log(window.URL.createObjectURL(blob))
        const blobUrl = window.URL.createObjectURL(blob);
        const a = window.document.createElement('a');
        let time= this.getCurrentTime();
          a.href = blobUrl;
          a.download =orderName+' '+time+'.zip';
        a.click();
        window.URL.revokeObjectURL(blobUrl);

      });
    });
    },
    downLoadKeeps() {
      if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
      let orderName=this.multipleSelection[0].orderName;
          this.$message({
                type: 'success',
                message: '正在死命下载中,请稍等!!!!',
              }),
      fetch("api/serviceCenter/orderInfo/downLoadKeeps", {
      body: JSON.stringify(this.multipleSelection),
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(res => {
      this.getTable()
      res.blob().then(blob => {
        // 转化为blobURL后再通过a标签下载
        console.log(window.URL.createObjectURL(blob))
        const blobUrl = window.URL.createObjectURL(blob);
        const a = window.document.createElement('a');
        let time= this.getCurrentTime();
          a.href = blobUrl;
          a.download =orderName+' '+time+'.zip';
        a.click();
        window.URL.revokeObjectURL(blobUrl);

      });
    });
    },
    downLoadFloors() {
      if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
      let orderName=this.multipleSelection[0].orderName;
          this.$message({
                type: 'success',
                message: '正在死命下载中,请稍等!!!!',
              }),
      fetch("api/serviceCenter/orderInfo/downLoadFloors", {
      body: JSON.stringify(this.multipleSelection),
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(res => {
      this.getTable()
      res.blob().then(blob => {
        // 转化为blobURL后再通过a标签下载
        console.log(window.URL.createObjectURL(blob))
        const blobUrl = window.URL.createObjectURL(blob);
        const a = window.document.createElement('a');
        let time= this.getCurrentTime();
          a.href = blobUrl;
          a.download =orderName+' '+time+'.zip';
        a.click();
        window.URL.revokeObjectURL(blobUrl);

      });
    });
    },
    downLoadPanels() {
      if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
      let orderName=this.multipleSelection[0].orderName;
          this.$message({
                type: 'success',
                message: '正在死命下载中,请稍等!!!!',
              }),
      fetch("api/serviceCenter/orderInfo/downLoadPanels", {
      body: JSON.stringify(this.multipleSelection),
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(res => {
      this.getTable()
      res.blob().then(blob => {
        // 转化为blobURL后再通过a标签下载
        console.log(window.URL.createObjectURL(blob))
        const blobUrl = window.URL.createObjectURL(blob);
        const a = window.document.createElement('a');
        let time= this.getCurrentTime();
          a.href = blobUrl;
          a.download =orderName+' '+time+'.zip';
        a.click();
        window.URL.revokeObjectURL(blobUrl);

      });
    });
    },
    downLoadManuscripts() {
      if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
      let orderName=this.multipleSelection[0].orderName;
          this.$message({
                type: 'success',
                message: '正在死命下载中,请稍等!!!!',
              }),
      fetch("api/serviceCenter/orderInfo/downLoadManuscripts", {
      body: JSON.stringify(this.multipleSelection),
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(res => {
      this.getTable()
      res.blob().then(blob => {
        // 转化为blobURL后再通过a标签下载
        console.log(window.URL.createObjectURL(blob))
        const blobUrl = window.URL.createObjectURL(blob);
        const a = window.document.createElement('a');
        let time= this.getCurrentTime();
          a.href = blobUrl;
          a.download =orderName+' '+time+'.zip';
        a.click();
        window.URL.revokeObjectURL(blobUrl);

      });
    });
    },
  }
  }
  </script>

  <style lang="scss" scoped>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 20px;
  }
  .body {
    overflow: auto;
  }

  .pagination {
    margin-top: 5px;
    margin-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
  }
  .el-pagination ::v-deep.el-pagination__total {
    line-height: 36px;
  }
  </style>
